import { useState } from 'react'
import dayjs from 'dayjs'
import Link from 'next/link'
import Image from 'next/image'
import Router, { useRouter } from 'next/router'
import useToastContext from "@byma/shared/hooks/useToastContext";
import Layout from 'components/Layout'
import { money } from '@byma/shared/helpers/formatters'
import useAuth from '@byma/shared/hooks/useAuth'
import useSWR from 'swr'
import fetcher from '@byma/shared/helpers/fetcher'
import Loader from '@byma/shared/components/Loader'
import GatewaySessionsTable from 'components/GatewaySessionsTable'
import useFilters from '@byma/shared/hooks/useFilters'

export default function GatewaySessions() {
    const session = useAuth()
    let { query, ...router } = useRouter()
    const { gatewaySessionId } = query
    const { token, user: currentUser } = session
    const { originalQueryString } = useFilters(query)
    const [isLoading, setIsLoading] = useState(false)

    const { data: gatewaySessionSelected, mutate } = useSWR(token && gatewaySessionId ? ['/api/gatewaySessions/get?gatewaySessionId=' + gatewaySessionId, null, token] : null, fetcher)
    const addToast = useToastContext()

    async function handleStatusChange(e) {
        e.preventDefault()
        setIsLoading(true)

        const body = {
            status: e.currentTarget.value,
        }

        try {
            const res = await fetch(`/api/gatewaySessions/edit?gatewaySessionId=${gatewaySessionId}`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Auth': token
                },
                body: JSON.stringify(body),
            })
            if (res.status === 200) {
                addToast('Saque editado com sucesso')
                mutate(['/api/gatewaySessions/get?gatewaySessionId=' + gatewaySessionId, null, token])
                setIsLoading(false)
            } else {
                throw new Error(await res.json())
            }
        } catch (error) {
            setIsLoading(false)
            addToast('Erro ao editar saque', 'error')
            console.error('An unexpected error happened occurred:', error)
        }
    }

    return (
        <Layout {...{ session }}>
            <GatewaySessionsTable />
            <div className={`fixed w-full h-full inset-0 transition-opacity duration-100 ${gatewaySessionId ? 'z-50 opacity-100' : '-z-1 opacity-0'}`} onClick={() => router.push(`/gatewaySessions?${originalQueryString}`)}>
                <div class="absolute w-full h-full bg-gray-900 opacity-50" />
                <div class="h-full modal-content p-3 absolute bg-white w-full md:w-11/12 md:max-w-2xl md:mx-auto md:rounded md:shadow-lg z-50 overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                    <div className="flex justify-end">
                        <Link href={`/gatewaySessions?${originalQueryString}`}>
                            <a>
                                <button>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </a>
                        </Link>
                    </div>
                    {gatewaySessionSelected?.result ? (
                        <>
                            <div className="mb-6">
                                <div className="flex justify-between items-center">
                                    <p className="text-xl font-bold">Saque #{gatewaySessionSelected?.result?._id}</p>
                                    <p className="text-gray-700">{dayjs(gatewaySessionSelected?.result?.created_at).format('DD/MM/YYYY HH:mm:ss')}</p>
                                </div>
                                <div className="box w-full mt-6">
                                    <p className="text-md font-bold">Status</p>
                                    <select name="status" className={`w-full p-4`} required defaultValue={gatewaySessionSelected?.result?.status} onChange={handleStatusChange}>
                                        <option value={'requested'}>Solicitado</option>
                                        <option value={'pending'}>Processando</option>
                                        <option value={'refused'}>Negado</option>
                                        <option value={'approved'}>Aprovado</option>
                                    </select>
                                </div>
                                <div className="box w-full mt-6">
                                    <div className="min-w-0 text-left">
                                        <p className="text-md font-bold">Criado por</p>
                                        <p className="truncate">
                                            {gatewaySessionSelected?.result?.created_by?.profile?.name || 'Usuário não encontrado'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="w-full py-12">
                            <Loader /> 
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    )
}
